import { Outlet } from 'react-router-dom'

export const SupportRootView = () => {
  return <Outlet />
}
